import {ChangeDetectionStrategy, Component, EventEmitter, forwardRef, OnInit, Output} from '@angular/core';
import {AbstractControl, ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {BaseComponent} from 'compob2b-libs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-three-state-checkbox',
  templateUrl: './three-state-checkbox.component.html',
  styleUrls: ['./three-state-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ThreeStateCheckboxComponent),
      multi: true,
    }
  ],
})
export class ThreeStateCheckboxComponent extends BaseComponent implements OnInit, ControlValueAccessor {
  @Output() change = new EventEmitter<boolean>();

  form = new FormGroup({
    checkbox: new FormControl(null)
  });
  private disabled = false;
  private touched = false;
  key: string = null;

  ngOnInit(): void {
    this.key = this.randomString(10);

    this.checkbox.valueChanges
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(_ => {
        this.markAsTouched();
        if (!this.disabled) {
          this.onChange(this.checkbox.value);
          this.change.next(true);
        }
      });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onChange: any = () => {
  }

  onTouched: any = (status: boolean | null) => {
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.detectChanges();
  }

  writeValue(value: any): void {
    this.checkbox.setValue(value, {emitEvent: false});
    this.cdr.detectChanges();
  }

  randomString(length) {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
  }

  markAsTouched(): void {
    if (!this.touched) {
      this.touched = true;
    }
  }

  get checkbox(): AbstractControl {
    return this.form.get('checkbox');
  }
}
